import { TherapistAction } from './constant';

export const getAppointmentSlotsAction = (payload: any) => {
  return {
    type: TherapistAction.GET_APPOINTMENT_SLOTS_REQUEST,
    payload,
  };
};

export const getAppointmentSlotsResetAction = () => {
  return {
    type: TherapistAction.GET_APPOINTMENT_SLOTS_RESET,
  };
};

export const scheduleAppointmentAction = (payload: any) => {
  return {
    type: TherapistAction.SCHEDULE_APPOINTMENT_REQUEST,
    payload,
  };
};

export const scheduleAppointmentResetAction = () => {
  return {
    type: TherapistAction.SCHEDULE_APPOINTMENT_RESET,
  };
};

export const getPatientTimeSlotsAction = (payload: any) => {
  return {
    type: TherapistAction.GET_PATIENT_TIME_SLOTS_REQUEST,
    payload,
  };
};

export const getPatientTimeSlotsResetAction = () => {
  return {
    type: TherapistAction.GET_PATIENT_TIME_SLOTS_RESET,
  };
};

export const scheduleRecurringAppointmentAction = (payload: any) => {
  return {
    type: TherapistAction.SCHEDULE_RECURRING_APPOINTMENT_REQUEST,
    payload,
  };
};

export const scheduleRecurringAppointmentResetAction = () => {
  return {
    type: TherapistAction.SCHEDULE_RECURRING_APPOINTMENT_RESET,
  };
};

export const setIsRecurringEditAction = (isRecurringEdit: boolean) => {
  return {
    type: TherapistAction.SET_IS_RECURRING_EDIT,
    payload: isRecurringEdit,
  };
};

export const resetIsRecurringEditAction = () => {
  return {
    type: TherapistAction.RESET_IS_RECURRING_EDIT,
  };
};

export const updateRecurringSeriesAction = (payload: any) => {
  return {
    type: TherapistAction.UPDATE_RECURRING_SERIES_REQUEST,
    payload,
  };
};

export const updateRecurringSeriesResetAction = () => {
  return {
    type: TherapistAction.UPDATE_RECURRING_SERIES_RESET,
  };
};

export const cancelRecurringSeriesAction = (payload: any) => {
  return {
    type: TherapistAction.CANCEL_RECURRING_SERIES_REQUEST,
    payload,
  };
};

export const cancelRecurringSeriesResetAction = () => {
  return {
    type: TherapistAction.CANCEL_RECURRING_SERIES_RESET,
  };
};

export const getRecurringAppointmentCountAction = (payload: any) => {
  return {
    type: TherapistAction.GET_RECURRING_APPOINTMENT_COUNT_REQUEST,
    payload,
  };
};

export const getRecurringAppointmentCountResetAction = () => {
  return {
    type: TherapistAction.GET_RECURRING_APPOINTMENT_COUNT_RESET,
  };
};